import * as types from "../actions/actionTypes";

const initialState = {
  providers: [],
  isLoading: false,
  isWaitingRequest: false,
  error: "",
  redirect: null,
  accountMismatch: false
};

export const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case types.getProviders:
      return {
        ...state,
        error: "",
        isLoading: true,
      };
    case types.getProvidersSuccess:
      return {
        ...state,
        isLoading: false,
        providers: action.providers,
      };
    case types.register:
      return {
        ...state,
        error: "",
        isWaitingRequest: true,
      };
    case types.registerSuccess:
      return {
        ...state,
        isWaitingRequest: false,
        redirect: null,
      };
    case types.registerFail:
      return {
        ...state,
        isWaitingRequest: false,
        redirect: null,
      };
    case types.authRedirect:
      return {
        ...state,
        redirect: action.redirect,
      };
    case types.authApiRequestError:
      return {
        ...state,
        error: action.error,
        isLoading: false,
        isWaitingRequest: false,
      };
    case types.checkUserConsent:
    case types.updateUserConsent:
    case types.resetUnlockCode:
    case types.resetVerificationCode:
      return {
        ...state,
        isLoading: true,
        isWaitingRequest: true,
      };
    case types.checkUserConsentSuccess:
    case types.updateUserConsentSuccess:
    case types.resetUnlockCodeSuccess:
    case types.resetVerificationCodeSuccess:
    case types.resetVerificationCodeError:
    case types.resetUnlockCodeError:
      return {
        ...state,
        isLoading: false,
        isWaitingRequest: false,
      };
    case types.accountMismatch:
      return {
        ...state,
        accountMismatch: true
      };
    case types.accountMatch:
      return {
        ...state,
        accountMismatch: false
      };
    default:
      return state;
  }
};
